var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-block-5"},[_c('ei-mask',{style:(_vm.leftTopImg)}),_c('ei-mask',{style:(_vm.rightTopImg)}),_c('ei-mask',{style:(_vm.leftBottomImg)}),_c('ei-mask',{style:(_vm.rightBottomImg)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }